/*
    Personalised product helpers (scoped by conditional load)
*/

window.updateQuantity = (selectElement) => {
    const selectedValue = selectElement.value
    const form = selectElement.closest('form')
    const quantityInput = form?.querySelector('input[name="quantity"]')

    if (quantityInput) {
        quantityInput.value = selectedValue
    }
}

window.onChangeEngraveOption = (input) => {
    const engraveVal = input.value
    const form = input.closest('form')
    const variantId = input.dataset.variantId

    if (form) {
        let targetInput = null
        form.querySelectorAll('.product-option').forEach((optionInput) => {
            if (!targetInput && optionInput.value === engraveVal) {
                targetInput = optionInput
            }
        })

        if (targetInput) {
            targetInput.click()
        }

        if (variantId) {
            const variantIdInput = form.querySelector('[name="id"]')
            if (variantIdInput) {
                variantIdInput.value = variantId
            }
        }
    }

    const imgSrc = input.nextElementSibling?.src
    if (imgSrc) {
        const engravingImage = document.querySelector('.engravingiamge img')
        if (engravingImage) {
            engravingImage.src = imgSrc
        }
    }
}

window.handleCloseClick = (event) => {
    event.preventDefault()
    const modalElement = document.getElementById('personalization-modal')
    if (!modalElement) return

    const modal = new bootstrap.Modal(modalElement)
    modal.show()
}

window.emptylienitemproperties = () => {
    const inputs = document.querySelectorAll('#engraving-modal input[name^="properties"], #engraving-modal textarea[name^="properties"]')
    inputs.forEach((input) => {
        if (input.type === 'radio' || input.type === 'checkbox') {
            input.checked = false
        } else {
            input.value = ''
        }
    })
}

window.onClickPersonalizationAgree = (event) => {
    event.preventDefault()
    event.stopPropagation()

    const agreeBtn = event.currentTarget
    if (agreeBtn.dataset.submitting === 'true') return

    const personalizationModal = document.querySelector('#personalization-modal')
    if (!personalizationModal) return

    const form = personalizationModal.closest('form')
        || document.querySelector('#product-content form[onsubmit*="onSubmitAtcForm"]')
    if (!form) return

    const selectedColorInput = form.querySelector('input[name="colorengrave"]:checked')
    const selectedVariantId = selectedColorInput?.dataset?.variantId
    if (selectedVariantId) {
        const variantIdInput = form.querySelector('[name="id"]')
        if (variantIdInput) {
            variantIdInput.value = selectedVariantId
        }
    }

    const qtySelect = form.querySelector('.quantity-dropdown')
    const qtyInput = form.querySelector('input[name="quantity"]')
    if (qtySelect && qtyInput) {
        qtyInput.value = qtySelect.value
    }

    agreeBtn.dataset.submitting = 'true'
    agreeBtn.disabled = true
    const modal = bootstrap.Modal.getOrCreateInstance(personalizationModal)
    modal.hide()

    // Completely bypass JS ATC handlers for personalised products.
    // Native form submit is more reliable when third-party scripts intercept fetch.
    const existingReturnTo = form.querySelector('input[name="return_to"][data-personalised-native]')
    if (!existingReturnTo) {
        const returnToInput = document.createElement('input')
        returnToInput.type = 'hidden'
        returnToInput.name = 'return_to'
        returnToInput.value = '/cart'
        returnToInput.setAttribute('data-personalised-native', 'true')
        form.appendChild(returnToInput)
    }

    const originalOnsubmit = form.getAttribute('onsubmit')
    if (originalOnsubmit) {
        form.setAttribute('data-original-onsubmit', originalOnsubmit)
        form.removeAttribute('onsubmit')
    }

    HTMLFormElement.prototype.submit.call(form)
}

const initEngravingFontLabel = () => {
    const fontInputs = document.querySelectorAll(".engraving-options-block input[name*='properties[Font]']")
    if (!fontInputs.length) return

    fontInputs.forEach((input) => {
        if (input.dataset.initFontLabelHandler === 'true') return
        input.dataset.initFontLabelHandler = 'true'

        input.addEventListener('input', () => {
            const fontValue = input.value
            const engravingBlock = input.closest('.engraving-options-block')

            if (engravingBlock) {
                const previousH6 = engravingBlock.previousElementSibling
                if (previousH6 && previousH6.tagName === 'H6' && previousH6.querySelector('span')) {
                    previousH6.querySelector('span').textContent = ` ${fontValue}`
                }
            }
        })
    })
}

const initPersonalisedProductPage = () => {
    initEngravingFontLabel()
}

document.addEventListener('DOMContentLoaded', initPersonalisedProductPage)
document.addEventListener('shopify:section:load', initPersonalisedProductPage)
